import { jsx as _jsx } from "react/jsx-runtime";
// TODO: implement when needed — KEK rotation status, secrets provider info, audit retention, active sessions with "Log out all".
export function SecurityTab() {
    return (_jsx("div", { style: { color: 'var(--text-secondary)' }, children: "Security settings \u2014 UI stub. Implement when needed." }));
}
